// @ts-ignore
import { checkIsObjectEmpty as _checkIsObjectEmpty } from "@my-scoot/exly-react-component-lib/build/esm/utils/common/dataTypes/object";
import type { checkIsObjectEmpty as checkIsObjectEmptyType } from "@my-scoot/exly-react-component-lib/build/types/utils/common/dataTypes/object";

export const checkIsObjectEmpty: typeof checkIsObjectEmptyType =
  _checkIsObjectEmpty;
